/**
 * Allow only same-app relative paths for post-login redirects (no open redirects).
 */
export function getSafeReturnTo(value: string | null | undefined): string | null {
  if (!value) return null;
  const trimmed = value.trim();
  if (!trimmed.startsWith('/') || trimmed.startsWith('//')) return null;
  if (trimmed.includes('\\') || trimmed.includes('://')) return null;
  return trimmed;
}

export function loginPathWithReturnTo(returnTo: string): string {
  const safe = getSafeReturnTo(returnTo);
  if (!safe) return '/users/login';
  return `/users/login?returnTo=${encodeURIComponent(safe)}`;
}
